export default __webpack_public_path__ + "assets/images/3deed8a7e4e4690d4082b4488c50d71a.png";